import {request} from './../request.js'
import AppConfig from '../../../config/AppConfig.js'
import {getLoginId} from '../../functions/Common.js'

// 获取当前管理员下的快捷语
export function getQuicklyReplyList(callback){
	request({
			method: 'post',
			url: 'QuicklyReply/getQuicklyReplyList',
			data: {
			  manage_id: getLoginId()
			}
	}).then((response)=>{
		callback(response.data)
	}).catch((error)=>{
		console.error(error)
		callback(false)
	})
}

// 获取当前管理员下的快捷语分组
export function getQuicklyReplyGroupList(callback){
	request({
			method: 'post',
			url: 'QuicklyReply/getGroupList',
			data: {
			  manage_id: getLoginId()
			}
	}).then((response)=>{
		callback(response.data)
	}).catch((error)=>{
		console.error(error)
		callback(false)
	})
}

// 保存快捷语
export function saveQuicklyReply(param,callback){
	param.manager_id = getLoginId()
	request({
			method: 'post',
			url: 'QuicklyReply/save',
			data: param
	}).then((response)=>{
		callback(response.data)
	}).catch((error)=>{
		console.error(error)
		callback(false)
	})
}

// 删除快捷语
export function delQuicklyReply(id,callback){
	request({
			method: 'post',
			url: 'QuicklyReply/delete',
			data: {
				id: id,
				manager_id: getLoginId()
			}
	}).then((response)=>{
		let res = response.data
		if(res.code == 1){
			callback(true)
		}else{
			callback(false)
		}
	}).catch((error)=>{
		console.error(error)
		callback(false)
	})
}

// 保存快捷语分组
export function saveQuicklyReplyGroup(title,callback){
	request({
			method: 'post',
			url: 'QuicklyReply/saveGroup',
			data: {
				title: title,
				manager_id: getLoginId()
			}
	}).then((response)=>{
		let res = response.data
		if(res.code == 1){
			callback(true)
		}else{
			callback(false)
		}
	}).catch((error)=>{
		console.error(error)
		callback(false)
	})
}

// 获取当前管理员下的智能快捷语发送列表
export function getQuicklyTechHistory(custom_wxid,fans_id,callback){
	request({
			method: 'post',
			url: 'QuicklyReply/getQuicklyTechHistory',
			data: {
			  custom_wxid: custom_wxid,
			  fans_id:fans_id
			}
	}).then((response)=>{
		callback(response.data)
	}).catch((error)=>{
		console.error(error)
		callback(false)
	})
}

// 获取当前管理员下的智能快捷语的一条
export function getQuicklyTech(custom_wxid,fans_id,fans_wxid,type,group_id,callback){
	request({
			method: 'post',
			url: 'QuicklyReply/getQuicklyTech',
			data: {
			  custom_wxid: custom_wxid,
			  fans_id:fans_id,
			  fans_wxid:fans_wxid,
			  type:type,
			  group_id:group_id,
			  manager_id: getLoginId()
			}
	}).then((response)=>{
		callback(response.data)
	}).catch((error)=>{
		console.error(error)
		callback(false)
	})
}

// 获取智能快捷分组列表
export function getQuicklyTechGG(callback){
	request({
			method: 'post',
			url: 'QuicklyReply/getQuicklyTechGG',
			data: {
				manager_id: getLoginId()
			}
	}).then((response)=>{
		callback(response.data)
	}).catch((error)=>{
		console.error(error)
		callback(false)
	})
}